import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Plus, Pencil, Trash2, LogOut } from 'lucide-react';
import { adminDeleteNews, adminListNews, adminLogout, mediaUrl } from '../../api/news';

const AdminNewsList = () => {
  const navigate = useNavigate();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = () => {
    setLoading(true);
    adminListNews()
      .then(setNews)
      .catch((e) => setError(e.message || 'Erro ao listar.'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  const onDelete = async (item) => {
    if (!window.confirm(`Excluir “${item.title}”?`)) return;
    try {
      await adminDeleteNews(item.id);
      load();
    } catch (e) {
      alert(e.message || 'Falha ao excluir.');
    }
  };

  const onLogout = async () => {
    try {
      await adminLogout();
    } catch {
      /* ignore */
    }
    navigate('/admin/login', { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#f5f5f3]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      <header className="bg-[#0e0e0e] text-white px-6 py-4 flex items-center justify-between">
        <div>
          <p className="text-[#C99A36] text-[10px] tracking-[0.35em] font-semibold">SETA ADMIN</p>
          <h1 className="text-lg font-bold">Notícias</h1>
        </div>
        <div className="flex items-center gap-3">
          <Link
            to="/admin/news/new"
            className="inline-flex items-center gap-2 bg-[#C99A36] text-black px-4 py-2 text-[11px] font-semibold tracking-wider hover:bg-[#E8C16A]"
          >
            <Plus size={14} /> NOVA
          </Link>
          <button
            type="button"
            onClick={onLogout}
            className="inline-flex items-center gap-2 border border-white/30 px-3 py-2 text-[11px] tracking-wider hover:border-[#C99A36]"
          >
            <LogOut size={14} /> SAIR
          </button>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-10">
        {loading && <p className="text-[#888]">Carregando…</p>}
        {error && <p className="text-red-600">{error}</p>}
        {!loading && news.length === 0 && <p className="text-[#888]">Nenhuma matéria.</p>}

        <ul className="space-y-3">
          {news.map((n) => (
            <li key={n.id} className="bg-white p-4 flex gap-4 items-center shadow-sm">
              <div className="w-20 h-14 bg-neutral-200 overflow-hidden flex-shrink-0">
                {n.image ? (
                  <img src={mediaUrl(n.image)} alt="" className="w-full h-full object-cover" />
                ) : null}
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-[#1a1a1a] text-sm truncate">{n.title}</p>
                <p className="text-[11px] text-[#888] mt-1">
                  {n.date} · {n.published ? 'Publicada' : 'Rascunho'} · /{n.slug}
                </p>
              </div>
              <Link
                to={`/admin/news/${n.id}`}
                className="p-2 text-[#555] hover:text-[#C99A36]"
                title="Editar"
              >
                <Pencil size={16} />
              </Link>
              <button
                type="button"
                onClick={() => onDelete(n)}
                className="p-2 text-[#555] hover:text-red-600"
                title="Excluir"
              >
                <Trash2 size={16} />
              </button>
            </li>
          ))}
        </ul>
      </main>
    </div>
  );
};

export default AdminNewsList;
